import { ref } from 'vue'
import { api } from '@/global/services/api'
import { WINTER_SERVICE_MODULE } from '@/modules/road-maintenance-module/winter-service-v2/common/config/constants'
import { buildWorkOrderReportEndpoint } from '@/modules/road-maintenance-module/winter-service-v2/reports/config/constants'

/**
 * Creating the coverage report of one work order.
 *
 * The endpoint renders the PDF and answers with the file itself, so there is nothing to
 * poll and nothing to store - it is fetched as a blob and handed straight to the
 * browser, the way the generated reports screen downloads its own exports.
 */
export function useWorkOrderReport () {
  // One report at a time: the PDF is rendered on request and a second press while it is
  // being drawn would only queue another render of the same thing.
  const isCreating = ref(false)

  const downloadReport = async (workOrder) => {
    const id = workOrder?.id

    if (!id || isCreating.value) {
      return false
    }

    let url = null

    try {
      isCreating.value = true

      const response = await api(WINTER_SERVICE_MODULE).get(
        buildWorkOrderReportEndpoint(id),
        null,
        { responseType: 'blob' }
      )

      url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }))

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `winter-service-coverage-${id}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      return true
    }
    catch (exception) {
      console.error(exception)
      return false
    }
    finally {
      if (url) {
        window.URL.revokeObjectURL(url)
      }

      isCreating.value = false
    }
  }

  return {
    isCreating,
    downloadReport
  }
}
